export function tryParseJson<T>(data?: string | null, defaultValue?: T): T | undefined {
  if (data === null || data === undefined) {
    return defaultValue;
  }

  try {
    return JSON.parse(data?.toString() ?? "") as unknown as T;
  } catch {
    return defaultValue;
  }
}
